export const SHADOW_FOCUS_MODES = [
    {
        id: 'shadow-descent',
        spread_slug: 'stesa-ombra',
        label: 'Shadow Descent',
        description: 'Riduce il campo ai punti di discesa e di attrito centrale.',
        highlighted_positions: [1, 2, 3],
        narrative_bias: 'shadow',
    },
    {
        id: 'shadow-integration',
        spread_slug: 'discesa-integrazione',
        label: 'Shadow Integration',
        description: 'Rilegge il processo a partire da verità, gesto e integrazione.',
        highlighted_positions: [5, 6, 7],
        hidden_positions: [1],
        narrative_bias: 'healing',
    },
    {
        id: 'shadow-healing-window',
        spread_slug: 'guarigione-interiore',
        label: 'Healing Window',
        description: 'Isola risorsa, azione e gesto di cura per una lettura più contenitiva.',
        highlighted_positions: [3, 4, 5, 6],
        narrative_bias: 'healing',
    },
];
//# sourceMappingURL=shadow-focus.js.map